import React from "react";
// import video from "../../assets/videos/next_cosmos_technology.mp4";

function TeamSection({ className }) {
  return (
    <section
      className={`team-section pt-115 rpt-95 pb-60 rpb-40 ${className || ""}`}
    >
      <div className="container">
        <div className="embed-responsive embed-responsive-16by9">
          <iframe
            width="560"
            height="315"
            className="embed-responsive-item"
            src="https://nct-social-media-icon.s3.ap-south-1.amazonaws.com/images/videos/next_cosmos_technology.mp4"
            title="Next Cosmos Technology Digital Future Transformation"
            sandbox="allow-scripts allow-presentation"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default TeamSection;
